import { Injectable } from '@angular/core';
import { CommonService } from 'src/app/shared/utils/common.service';
import { UtilsService } from 'src/app/shared/utils/utils.service';
import { indicadoresVivosModulo } from '../../indicadores-vivos/diccionarios/indicadoresVivosModulo';
import { Observable } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class IndicadoresVivosService {

  diccionarioUrl: any;
  urlMaestros: string;
  urlDistribuidor: string;
  urlPresupuestoComercial: string;
  constructor(
    private commom: CommonService,
    private utilServices: UtilsService
  ) {
    this.urlMaestros = this.utilServices.getDatosMaestros();
    this.urlDistribuidor = this.utilServices.getDistribuidor();
    this.urlPresupuestoComercial = this.utilServices.getPresupuestoComercial();
    //this.urlPresupuestoComercial = "http://localhost:8080/presupuesto-comercial-api/v1/api/services/";
    
    // this.urlDistribuidor = 'localhost:8080/distribuidor/distribuidor/v1/api/service';
    this.diccionarioUrl = indicadoresVivosModulo.url.indicadores;
  }

  getReportIndicadores(anio: string, mesInicio: string, mesFin: string, version: string, tipoReporte: string, tipoPresupuesto: string, canal: number = 0, vendedorA: string = "", vendedorB: string = "")
    {
      let queryParam =  "?tipoReporte=" + tipoReporte + "&anio=" + anio + "&mesInicio=" + mesInicio + "&mesFin=" + mesFin + 
      "&version=" + version + "&tipoPresupuesto=" + tipoPresupuesto + "&canal=" + canal;

      if(vendedorA != null){
        console.log("vendedores inicio y fin", vendedorA, vendedorB);
        queryParam = queryParam + "&vendedorInicio=" + vendedorA + "&vendedorFin=" + vendedorB;
      }

      return this.commom.peticionGetConHeader(this.urlPresupuestoComercial + this.diccionarioUrl.reporte + queryParam);
  }

  // procesarCsvIndicadores(tipo: string, formData: any) {
  //   return this.commom.peticionPost(this.urlPresupuestoComercial + this.diccionarioUrl.recepcionCsv + `/${tipo}`, formData);
  // }

  procesarCsvIndicadores(formData: FormData, conversor: boolean, tipo: any, canal: any): Observable<any[]> {
    return this.commom.peticionPostConHeader(this.urlPresupuestoComercial + this.diccionarioUrl.recepcionCsv 
      + '?conversor=' + conversor + '&tipoPresupuesto=' + tipo + '&canal=' + canal, formData);
  }

  procesarCsvIndicadoresMarcasFacturas(formData: FormData) {
    return this.commom.peticionPostConHeader(this.urlPresupuestoComercial + this.diccionarioUrl.recepcionCsvMarcasfacturas, formData);
  }

  procesarCsvSellOut(formData: FormData, anio: any) {
    return this.commom.peticionPostConHeader(this.urlPresupuestoComercial + this.diccionarioUrl.recepcionCsvSellOut + '?anio=' + anio, formData);
  }

  saveCsvIndicadores(listObj: any[], opcion: string) { //
    console.log("saveCsvIndicadores", listObj, opcion)
    return this.commom.peticionPostConHeader(this.urlPresupuestoComercial + this.diccionarioUrl.recepcionCsvSave + opcion, listObj);
  }

  saveCsvSellOut(listObj: any[]) { //
    console.log("saveCsvIndicadores", listObj)
    return this.commom.peticionPostConHeader(this.urlPresupuestoComercial + this.diccionarioUrl.recepcionCsvSaveSellOut, listObj);
  }

  saveCsvIndicadoresMarcasFacturas(listObj: any[], opcion: string) {
    return this.commom.peticionPostConHeader(this.urlPresupuestoComercial + this.diccionarioUrl.recepcionCsvSaveMarcasFacturas + `${opcion}`, listObj);
  }

  getAllIndicadores() {
    return this.commom.peticionGetConHeader(this.urlPresupuestoComercial + this.diccionarioUrl.presupuestoVentas);
  }

  getAllIndicadoresMarcasFacturas(innObj) {
    return this.commom.peticionGetConHeader(this.urlPresupuestoComercial + this.diccionarioUrl.presupuestoVentasMarcasFacturasFiltrar + "?anio=" + innObj.anio + "&mesInicio=" + innObj.desde + "&mesFin=" + innObj.hasta + "&version=" + innObj.version + "&agencia=" + innObj.agencia);
  }

  getAllIndicadoresSellOut() {
    return this.commom.peticionGetConHeader(this.urlPresupuestoComercial + this.diccionarioUrl.recepcionCsvSellOutTodos);
  }

  saveIndicadores(innObj: any) {
    return this.commom.peticionPostConHeader(this.urlPresupuestoComercial + this.diccionarioUrl.presupuestoVentas, innObj);
  }

  saveIndicadoresMarcasFacturas(innObj: any) {
    return this.commom.peticionPostConHeader(this.urlPresupuestoComercial + this.diccionarioUrl.presupuestoVentasMarcasFacturas, innObj);
  }

  saveIndicadoresSellOut(innObj: any) {
    return this.commom.peticionPostConHeader(this.urlPresupuestoComercial + this.diccionarioUrl.presupuestoSellOut, innObj);
  }

  updateIndicadores(innObj: any) {
    return this.commom.peticionPutConHeader(this.urlPresupuestoComercial + this.diccionarioUrl.presupuestoVentas, innObj);
  }

  updateIndicadoresMarcasFacturas(innObj: any) {
    return this.commom.peticionPutConHeader(this.urlPresupuestoComercial + this.diccionarioUrl.presupuestoVentasMarcasFacturas, innObj);
  }

  updateIndicadoresSellOut(innObj: any) {
    return this.commom.peticionPutConHeader(this.urlPresupuestoComercial + this.diccionarioUrl.presupuestoSellOut, innObj);
  }

  deleteIndicadores(innObj: any) {
    return this.commom.peticionPostConHeader(this.urlPresupuestoComercial + this.diccionarioUrl.presupuestoVentasDelete, innObj);
  }

  deleteIndicadoresMarcasFacturas(innObj: any) {
    return this.commom.peticionDeleteConHeader(this.urlPresupuestoComercial + this.diccionarioUrl.presupuestoVentasDeleteMarcasFacturas, innObj);
  }

  deleteIndicadoresSellOut(innObj: any) {
    return this.commom.peticionDeleteConHeader(this.urlPresupuestoComercial + this.diccionarioUrl.presupuestoSellOutDelete, innObj);
  }

  getVendedor(innCodigoVendedor: string) {
    return this.commom.peticionGetConHeader(this.urlMaestros + this.diccionarioUrl.getClienteInBann + `/${innCodigoVendedor}`);
  }

  changeVendedorPresupuesto(innObj: any) {
    return this.commom.peticionPostConHeader(this.urlPresupuestoComercial + this.diccionarioUrl.changePresupuestoVenta, innObj);
  }

  getChangePresupuestoVenta(innObj: any) {
    return this.commom.peticionPostConHeader(this.urlPresupuestoComercial + this.diccionarioUrl.getChangePresupuestoVenta, innObj);
  }

  getAllVersionesPresupuesto() {
    return this.commom.peticionGetConHeader(this.urlPresupuestoComercial + this.diccionarioUrl.getVersionPresupuesto);
  }

  getAgencias() {
    return this.commom.peticionGetConHeader(this.urlMaestros + indicadoresVivosModulo.url.maestros.getAgencias);
  }

  validarVededor(idVendedor) {
    return this.commom.peticionGetConHeader(
      this.urlMaestros + this.diccionarioUrl.url.maestros.getVendedor + idVendedor
    );
  }


// PRESUPUESTO PROPIEDADES
presupuestoPropiedadesUploadCSV(formData: FormData): Observable<any[]> {
  return this.commom.peticionPostConHeader(this.urlPresupuestoComercial + this.diccionarioUrl.propiedadesUpload, formData);
}

presupuestoPropiedadesUploadSave(formData: any) {
  return this.commom.peticionPostConHeader(this.urlPresupuestoComercial + this.diccionarioUrl.propiedadesSave, formData);
}

presupuestoPropiedadesCreate(formData: FormData) {
  return this.commom.peticionPostConHeader(this.urlPresupuestoComercial + this.diccionarioUrl.propiedadesCrud, formData);
}

presupuestoPropiedadesDelete(formData: FormData) {
  return this.commom.peticionDeleteConHeader(this.urlPresupuestoComercial + this.diccionarioUrl.propiedadesCrud, formData);
}

presupuestoPropiedadesList() {
  return this.commom.peticionGetConHeader(this.urlPresupuestoComercial + this.diccionarioUrl.propiedadesCrud);
}

presupuestoPropiedadesUpdate(formData: FormData) {
  return this.commom.peticionPutConHeader(this.urlPresupuestoComercial + this.diccionarioUrl.propiedadesCrud, formData);
}


// PRESUPUESTO COMERCIAL VENTAS
getPresupuestoVentas(anio: string, mesInicio: string, mesFin: string, version: string, tipoPresupuesto: string) {
  return this.commom.peticionGetConHeader(this.urlPresupuestoComercial + this.diccionarioUrl.presupuestoVenta + "?anio=" + anio + "&mesInicio=" + mesInicio + "&mesFin=" + mesFin + "&version=" + version + "&tipoPresupuesto=" + tipoPresupuesto);
}

deleteMasivoPresupuesto(payload:any) {
  return this.commom.peticionDeleteConHeader(this.urlPresupuestoComercial + this.diccionarioUrl.presupuestoVentasDelete+"/masivo", payload);
}

//T25111 add PRESUPUESTO PROMO
presupuestoPromoUploadCSV(formData: FormData): Observable<any[]> {
  return this.commom.peticionPostConHeader(this.urlPresupuestoComercial + this.diccionarioUrl.promocionUpload, formData);
}

presupuestoPromoUploadSave(formData: any) {
  return this.commom.peticionPostConHeader(this.urlPresupuestoComercial + this.diccionarioUrl.promocionSave, formData);
}

presupuestoPromoCreate(formData: FormData) {
  return this.commom.peticionPostConHeader(this.urlPresupuestoComercial + this.diccionarioUrl.promocionCrud, formData);
}

presupuestoPromoDelete(formData: FormData) {
  return this.commom.peticionDeleteConHeader(this.urlPresupuestoComercial + this.diccionarioUrl.promocionCrud, formData);
}

presupuestoPromoList() {
  return this.commom.peticionGetConHeader(this.urlPresupuestoComercial + this.diccionarioUrl.promocionCrud);
}

presupuestoPromosUpdate(formData: FormData) {
  return this.commom.peticionPutConHeader(this.urlPresupuestoComercial + this.diccionarioUrl.promocionCrud, formData);
}

getReportPresupuestoPromo(anio: string, canalVenta: string, unidadNegocio: string, canal: string, 
                          SubCanal: string, grupoPrecio:string, material: string) {
  let queryParam= "?anio=" + anio + 
                    "&canalVenta=" + canalVenta + 
                    "&unidadNegocio=" + unidadNegocio + 
                    "&canal=" + canal + 
                    "&subCanal=" + SubCanal + 
                    "&grupoPrecio=" + grupoPrecio + 
                    "&material=" + material;

  return this.commom.peticionGetConHeader(this.urlPresupuestoComercial + this.diccionarioUrl.promocionReport+queryParam);

}

}